"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CitoModulesService = void 0;
class CitoModulesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1CitoModules({ authorization = 'Bearer <token>', locale, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/CitoModules',
            headers: {
                Authorization: authorization,
            },
            query: {
                locale: locale,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.CitoModulesService = CitoModulesService;
